import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/Button';
import { ShieldAlert, FileText, AlertTriangle, Eye } from 'lucide-react';
export function Hero() {
  const [counters, setCounters] = useState({
    risks: 0,
    docs: 0,
    contradictions: 0,
    hidden: 0
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setCounters(prev => ({
        risks: Math.min(prev.risks + 1, 14),
        docs: Math.min(prev.docs + 12, 342),
        contradictions: Math.min(prev.contradictions + 1, 7),
        hidden: Math.min(prev.hidden + 1, 23)
      }));
    }, 50);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative bg-navy pt-24 pb-32 overflow-hidden" data-id="element-208">
      {/* Background subtle grid/glow */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-20" data-id="element-209" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-210">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-211">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-212">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-6" data-id="element-213">
              Entiende una licitación mejor que cualquier competidor.
            </h1>
            <p className="text-lg md:text-xl text-slate-400 mb-8 leading-relaxed" data-id="element-214">
              Prisma analiza cientos de documentos técnicos, contractuales y
              comerciales para identificar riesgos, contradicciones, requisitos
              ocultos y oportunidades antes de presentar una oferta.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-215">
              <Button size="lg" variant="solid" data-id="element-216">
                Solicitar Demo
              </Button>
              <Button size="lg" variant="outline" data-id="element-217">
                Ver Ejemplo
              </Button>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-218">
            {/* Mock Product Panel */}
            <div className="bg-slate-900 border border-slate-700 rounded-xl shadow-2xl overflow-hidden flex flex-col" data-id="element-219">
              {/* Panel Header */}
              <div className="bg-slate-800/50 border-b border-slate-700 px-4 py-3 flex items-center justify-between" data-id="element-220">
                <div className="flex items-center gap-2" data-id="element-221">
                  <div className="w-3 h-3 rounded-full bg-risk" data-id="element-222" />
                  <div className="w-3 h-3 rounded-full bg-amber-500" data-id="element-223" />
                  <div className="w-3 h-3 rounded-full bg-emerald-500" data-id="element-224" />
                </div>
                <div className="text-xs font-medium text-slate-400 uppercase tracking-wider" data-id="element-225">
                  Análisis de Licitación ID-8492
                </div>
              </div>

              {/* Panel Body */}
              <div className="p-6" data-id="element-226">
                <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-227">
                  <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4" data-id="element-228">
                    <div className="flex items-center gap-2 text-slate-400 mb-2" data-id="element-229">
                      <ShieldAlert size={16} className="text-risk" data-id="element-230" />
                      <span className="text-xs font-medium uppercase" data-id="element-231">
                        Riesgos
                      </span>
                    </div>
                    <div className="text-3xl font-bold text-white" data-id="element-232">
                      {counters.risks}
                    </div>
                  </div>
                  <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4" data-id="element-233">
                    <div className="flex items-center gap-2 text-slate-400 mb-2" data-id="element-234">
                      <FileText size={16} className="text-techblue" data-id="element-235" />
                      <span className="text-xs font-medium uppercase" data-id="element-236">
                        Documentos
                      </span>
                    </div>
                    <div className="text-3xl font-bold text-white" data-id="element-237">
                      {counters.docs}
                    </div>
                  </div>
                  <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4" data-id="element-238">
                    <div className="flex items-center gap-2 text-slate-400 mb-2" data-id="element-239">
                      <AlertTriangle size={16} className="text-amber-500" data-id="element-240" />
                      <span className="text-xs font-medium uppercase" data-id="element-241">
                        Contradicciones
                      </span>
                    </div>
                    <div className="text-3xl font-bold text-white" data-id="element-242">
                      {counters.contradictions}
                    </div>
                  </div>
                  <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-4" data-id="element-243">
                    <div className="flex items-center gap-2 text-slate-400 mb-2" data-id="element-244">
                      <Eye size={16} className="text-cyan" data-id="element-245" />
                      <span className="text-xs font-medium uppercase" data-id="element-246">
                        Req. Ocultos
                      </span>
                    </div>
                    <div className="text-3xl font-bold text-white" data-id="element-247">
                      {counters.hidden}
                    </div>
                  </div>
                </div>

                <div className="space-y-3" data-id="element-248">
                  <div className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-2" data-id="element-249">
                    Hallazgos Críticos
                  </div>

                  <motion.div initial={{
                  opacity: 0,
                  x: 20
                }} animate={{
                  opacity: 1,
                  x: 0
                }} transition={{
                  delay: 0.8
                }} className="flex items-start gap-3 p-3 bg-risk/10 border border-risk/20 rounded-md" data-id="element-250">
                    <div className="w-2 h-2 rounded-full bg-risk mt-1.5 shrink-0" data-id="element-251" />
                    <div data-id="element-252">
                      <p className="text-sm font-medium text-slate-200" data-id="element-253">
                        Multa diaria por retraso excede límite legal
                      </p>
                      <p className="text-xs text-slate-400 mt-1" data-id="element-254">
                        Bases Administrativas Especiales, Pág 42 vs Ley 19.886
                      </p>
                    </div>
                  </motion.div>

                  <motion.div initial={{
                  opacity: 0,
                  x: 20
                }} animate={{
                  opacity: 1,
                  x: 0
                }} transition={{
                  delay: 1.0
                }} className="flex items-start gap-3 p-3 bg-slate-800/50 border border-slate-700 rounded-md" data-id="element-255">
                    <div className="w-2 h-2 rounded-full bg-amber-500 mt-1.5 shrink-0" data-id="element-256" />
                    <div data-id="element-257">
                      <p className="text-sm font-medium text-slate-200" data-id="element-258">
                        Contradicción en especificación de material
                      </p>
                      <p className="text-xs text-slate-400 mt-1" data-id="element-259">
                        Plano E-04 indica Acero A36, EETT indica Acero A572
                      </p>
                    </div>
                  </motion.div>
                </div>
              </div>
            </div>

            {/* Decorative Prism Glow */}
            <div className="absolute -inset-4 bg-cyan/20 blur-3xl -z-10 rounded-full opacity-50" data-id="element-260" />
          </motion.div>
        </div>
      </div>
    </section>;
}